// Shared plan-presentation constants. Single source so SubscriptionGate
// (upsell copy) and Billing (the plan grid) can't drift on which tier
// unlocks which feature, or on the tier ordering.

// PLAN_ORDER (the canonical base-tier ordering, cheapest → most; used to rank
// the current plan against catalog cards) is GENERATED from
// internal/glows.BaseTierOrder so it can't drift from the server's planRank /
// plan catalog (cross-boundary-audit Slice 8). Edit the Go source + run
// `task plans:sync`; never edit the generated file by hand.
import { PLAN_ORDER } from './plan-order.gen'
export { PLAN_ORDER }

// PlanFeatureFlag is the set of boolean entitlement flags the gating UI
// reads off the Subscription. Re-exported here (rather than redeclared in
// each component) so the flag union has one home.
export type PlanFeatureFlag =
  | 'can_set_public'
  | 'can_add_emails'
  | 'can_add_patterns'
  | 'can_choose_name'
  | 'can_get_cname'
  | 'can_set_accounts'
  | 'can_hide_branding'

// FEATURE_TIER maps each gated feature flag to the LOWEST tier that
// unlocks it (cumulative, D1 — Flood is a superset of Beam). Pinned to the
// backlit_* price metadata the server's plan catalog folds (CLAUDE.md §11):
// Beam grants can_add_emails + can_choose_name + can_hide_branding; Flood
// adds the rest (incl. can_set_accounts, the open self-serve Accounts mode).
export const FEATURE_TIER: Record<PlanFeatureFlag, 'Beam' | 'Flood'> = {
  can_add_emails: 'Beam',
  can_choose_name: 'Beam',
  can_hide_branding: 'Beam',
  can_add_patterns: 'Flood',
  can_get_cname: 'Flood',
  can_set_public: 'Flood',
  can_set_accounts: 'Flood',
}

export type PlanName = (typeof PLAN_ORDER)[number]

// planRank returns the index of a plan in PLAN_ORDER, or -1 for an unknown
// value (so an unexpected server string sorts before every known tier and
// never silently masquerades as a higher plan). A CUSTOM subscriber's
// subscription.plan carries their price's backlit_plan slug verbatim, which
// also ranks -1 — never rank subscription.plan without an is_custom guard,
// or a custom plan would read as below Spark.
export function planRank(plan: string): number {
  return PLAN_ORDER.indexOf(plan as PlanName)
}
